export enum EDietStatusList {
	ACTIVE = 'active',
	INACTIVE = 'inactive',
	ALL = 'all',
}

export enum EDietStatus {
	ACTIVE = 'active',
	INACTIVE = 'inactive',
	ARCHIVED = 'archived',
}

export enum EDietType {
	STANDARD = 'standard',
	MENU_SELECTION = 'menu_selection',
}

export enum EDietGroup {
	STANDARD = 'standard',
	MENU_SELECTION = 'menu_selection',
	DAILY_SELECTION = 'daily_selection',
	KIDS_MENU = 'kids_menu',
	FOODPACK = 'foodpack',
}

export enum EDietCategory {
	MEALS = 1,
	FOODPACK = 2,
	CLASSICS = 3,
	ADDONS = 4,
	MEALPREPS = 5,
	KIDS = 6,
}

/**
 * Kategorie dozwolone dla danej grupy diety
 * DAILY_SELECTION / FOODPACK: bez CLASSICS i MEALPREPS.
 * KIDS tylko dla KIDS_MENU, DAILY_SELECTION, FOODPACK.
 */
export const ALLOWED_DIET_CATEGORIES_BY_GROUP: Record<EDietGroup, EDietCategory[]> = {
	[EDietGroup.STANDARD]: [EDietCategory.MEALS, EDietCategory.FOODPACK, EDietCategory.CLASSICS, EDietCategory.KIDS],
	[EDietGroup.MENU_SELECTION]: [
		EDietCategory.MEALS,
		EDietCategory.FOODPACK,
		EDietCategory.CLASSICS,
		EDietCategory.KIDS,
	],
	[EDietGroup.DAILY_SELECTION]: [EDietCategory.MEALS, EDietCategory.KIDS, EDietCategory.FOODPACK],
	[EDietGroup.FOODPACK]: [EDietCategory.MEALS, EDietCategory.KIDS, EDietCategory.FOODPACK],
	[EDietGroup.KIDS_MENU]: [EDietCategory.FOODPACK, EDietCategory.CLASSICS, EDietCategory.KIDS],
}

export const DIET_CATEGORY_LABELS: Record<EDietCategory, string> = {
	[EDietCategory.MEALS]: 'Dania',
	[EDietCategory.FOODPACK]: 'Foodpack',
	[EDietCategory.CLASSICS]: 'Klasyki',
	[EDietCategory.ADDONS]: 'Dodatki',
	[EDietCategory.MEALPREPS]: 'Mealprepy',
	[EDietCategory.KIDS]: 'Kids menu',
}
